/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import styles from "./LocationLabelSelector.module.css";
import { getLocationLabels } from "../../shared/repos/graphql/user";
import Loader from "../Loader/Loader";

export const LOCATION_LABEL_CUSTOM_DATA_PART = 'location-label-custom-input';

let locationLabelInputIdCounter = 0;

const nextLocationLabelInputId = () => {
  locationLabelInputIdCounter += 1;
  return `location-label-input-${locationLabelInputIdCounter}`;
};

class LocationLabelSelector extends Component {

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.labelRequestId = 0;
    this.inputId = nextLocationLabelInputId();
    this.listboxId = `${this.inputId}-listbox`;
    this.state = {
      label: '',
      id: '',
      customerLabels: [],
      isCustomerLabelsVisible: false,
      isProcessing: false,
      activeOptionIndex: -1,
    };
  }

  componentDidMount() {
    const { value } = this.props;
    document.addEventListener('click', this.handleClickOutside);
    if (value) {
      this.setState({
        label: value.label,
        id: value.id,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    this.cancelPendingLabelSearch();
  }

  getIsListOpen = () => {
    const { customerLabels, isCustomerLabelsVisible } = this.state;
    return isCustomerLabelsVisible && customerLabels.length > 0;
  }

  cancelPendingLabelSearch = () => {
    this.labelRequestId += 1;
    if (typeof this.locationLabels.cancel === 'function') {
      this.locationLabels.cancel();
    }
  }

  closeSuggestionList = () => {
    this.setState({
      isCustomerLabelsVisible: false,
      activeOptionIndex: -1,
    });
  }

  handleClickOutside = (event) => {
    if (event && this.containerRef.current && this.containerRef.current.contains(event.target)) {
      return;
    }
    this.closeSuggestionList();
  }

  tryToFoundLabel = (label, customerLabels) => {
    const found = customerLabels.find((customerLabel) => {
      return customerLabel.label && label && customerLabel.label.toLowerCase().trim() === label.toLowerCase().trim();
    });
    return found || null;
  }

  applyLabelSearchResults = (label, customerLabels, onChange) => {
    const founded = this.tryToFoundLabel(label, customerLabels);
    const labelResultData = {
      label: founded ? founded.label : label,
      id: founded ? founded.id : null,
    };
    this.setState({
      customerLabels,
      isCustomerLabelsVisible: customerLabels.length > 0,
      isProcessing: false,
      activeOptionIndex: -1,
      id: founded ? founded.id : null,
    });
    onChange(label ? labelResultData : null);
  }

  locationLabels = _.debounce(async (label) => {
    const requestId = this.labelRequestId + 1;
    this.labelRequestId = requestId;
    const { onChange } = this.props;

    try {
      let results = { data: { me: { locationLabels: [] } } };
      if (label) {
        results = await getLocationLabels(true, true, label, 5);
      }
      if (requestId !== this.labelRequestId) {
        return;
      }
      this.applyLabelSearchResults(label, results.data.me.locationLabels, onChange);
    } catch (error) {
      if (requestId !== this.labelRequestId) {
        return;
      }
      this.setState({
        isProcessing: false,
        isCustomerLabelsVisible: false,
        activeOptionIndex: -1,
      });
    }
  }, 500);

  onInputChange = async (e) => {
    const { value } = e.target;
    this.setState({
      label: value,
      isProcessing: true,
      activeOptionIndex: -1,
    });
    this.locationLabels(value);
  }

  handleInputKeyDown = (event) => {
    const { customerLabels, activeOptionIndex } = this.state;
    const isOpen = this.getIsListOpen();

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!isOpen && customerLabels.length > 0) {
        this.setState({ isCustomerLabelsVisible: true, activeOptionIndex: 0 });
        return;
      }
      if (isOpen) {
        const nextIndex = activeOptionIndex < customerLabels.length - 1 ? activeOptionIndex + 1 : 0;
        this.setState({ activeOptionIndex: nextIndex });
      }
      return;
    }

    if (event.key === 'ArrowUp') {
      if (!isOpen) {
        return;
      }
      event.preventDefault();
      const nextIndex = activeOptionIndex > 0 ? activeOptionIndex - 1 : customerLabels.length - 1;
      this.setState({ activeOptionIndex: nextIndex });
      return;
    }

    if (event.key === 'Enter') {
      if (!isOpen || activeOptionIndex < 0) {
        return;
      }
      event.preventDefault();
      this.onSelectCustomerLabel(customerLabels[activeOptionIndex]);
      return;
    }

    if (event.key === 'Escape') {
      if (!isOpen) {
        return;
      }
      event.preventDefault();
      this.closeSuggestionList();
    }
  }

  handleLabelItemMouseDown = (event) => {
    event.preventDefault();
  }

  onSelectCustomerLabel = (label) => {
    const { onChange } = this.props;
    this.cancelPendingLabelSearch();
    this.setState({
      label: label.label,
      id: label.id,
      isCustomerLabelsVisible: false,
      isProcessing: false,
      activeOptionIndex: -1,
    });
    onChange(label);
  }

  getInputAriaProps = () => {
    const { activeOptionIndex } = this.state;
    const isOpen = this.getIsListOpen();
    return {
      role: 'combobox',
      'aria-autocomplete': 'list',
      'aria-expanded': isOpen,
      'aria-controls': this.listboxId,
      'aria-activedescendant': isOpen && activeOptionIndex >= 0
        ? `${this.listboxId}-option-${activeOptionIndex}`
        : undefined,
    };
  }

  renderCustomerLabels() {
    const { customerLabels, id, activeOptionIndex } = this.state;
    return (
      <div
        id={this.listboxId}
        role="listbox"
        tabIndex={-1}
        className={styles.labelsContainer}
        onMouseDown={this.handleLabelItemMouseDown}
      >
        { customerLabels.map((label, index) => (
          <div
            key={label.id}
            id={`${this.listboxId}-option-${index}`}
            role="option"
            tabIndex={-1}
            aria-selected={id === label.id || activeOptionIndex === index}
            className={[
              styles.labelItem,
              'dark:text-dark',
              id === label.id ? styles.current : null,
              activeOptionIndex === index ? styles.activeOption : null,
            ].join(' ')}
            onMouseDown={this.handleLabelItemMouseDown}
            onClick={() => this.onSelectCustomerLabel(label)}
            onMouseEnter={() => this.setState({ activeOptionIndex: index })}
          >
            {label.label}
          </div>
        ))}
      </div>
    );
  }

  renderInput(placeholder, inputClassName, brandRefresh) {
    const { label } = this.state;
    const hasValue = Boolean(label && label.trim());
    const {
      role,
      'aria-autocomplete': ariaAutocomplete,
      'aria-expanded': ariaExpanded,
      'aria-controls': ariaControls,
      'aria-activedescendant': ariaActivedescendant,
    } = this.getInputAriaProps();

    if (brandRefresh) {
      return (
        <div
          className={[
            styles.brandRefreshLabelField,
            hasValue ? styles.brandRefreshLabelFieldHasValue : null,
          ].join(' ')}
        >
          <input
            id={this.inputId}
            data-part={LOCATION_LABEL_CUSTOM_DATA_PART}
            type="text"
            placeholder=" "
            className={[styles.brandRefreshLabelInput, 'inputDarkModeOverride'].join(' ')}
            role={role}
            aria-autocomplete={ariaAutocomplete}
            aria-expanded={ariaExpanded}
            aria-controls={ariaControls}
            aria-activedescendant={ariaActivedescendant}
            value={label}
            onChange={this.onInputChange}
            onKeyDown={this.handleInputKeyDown}
          />
          <label htmlFor={this.inputId}>{placeholder}</label>
        </div>
      );
    }

    return (
      <input
        id={this.inputId}
        type="text"
        placeholder={placeholder}
        className={[inputClassName].join(' ')}
        role={role}
        aria-autocomplete={ariaAutocomplete}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-activedescendant={ariaActivedescendant}
        value={label}
        onChange={this.onInputChange}
        onKeyDown={this.handleInputKeyDown}
      />
    );
  }

  render() {
    const { className, inputClassName, placeholder, brandRefresh } = this.props;
    const { isCustomerLabelsVisible, isProcessing, customerLabels } = this.state;
    const isCustomerLabelsAvailable = isCustomerLabelsVisible && customerLabels.length > 0;

    return (
      <div ref={this.containerRef} className={[styles.labelSelectorContainer, className].join(' ')}>
        {this.renderInput(placeholder, inputClassName, brandRefresh)}
        { isProcessing ? (<Loader height={20} className={styles.loader} />) : null }
        { isCustomerLabelsAvailable ? this.renderCustomerLabels() : null }
      </div>
    );
  }
}

LocationLabelSelector.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  brandRefresh: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }), PropTypes.oneOf([null])]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

LocationLabelSelector.defaultProps = {
  className: "",
  inputClassName: "",
  brandRefresh: false,
  value: null,
  onChange: () => {},
  placeholder: "",
};

export default LocationLabelSelector;
